[
  { "code": "aa", "name": { "en": "Afar", "es": "Afar" } },
  { "code": "ab", "name": { "en": "Abkhazian", "es": "Abjasio" } },
  { "code": "ae", "name": { "en": "Avestan", "es": "Avéstico" } },
  { "code": "af", "name": { "en": "Afrikaans", "es": "Afrikáans" } },
  { "code": "ak", "name": { "en": "Akan", "es": "Akan" } },
  { "code": "am", "name": { "en": "Amharic", "es": "Amárico" } },
  { "code": "an", "name": { "en": "Aragonese", "es": "Aragonés" } },
  { "code": "ar", "name": { "en": "Arabic", "es": "Árabe" } },
  { "code": "as", "name": { "en": "Assamese", "es": "Asamés" } },
  { "code": "av", "name": { "en": "Avaric", "es": "Avar" } },
  { "code": "ay", "name": { "en": "Aymara", "es": "Aimara" } },
  { "code": "az", "name": { "en": "Azerbaijani", "es": "Azerbaiyano" } },
  { "code": "ba", "name": { "en": "Bashkir", "es": "Baskir" } },
  { "code": "be", "name": { "en": "Belarusian", "es": "Bielorruso" } },
  { "code": "bg", "name": { "en": "Bulgarian", "es": "Búlgaro" } },
  { "code": "bi", "name": { "en": "Bislama", "es": "Bislama" } },
  { "code": "bm", "name": { "en": "Bambara", "es": "Bambara" } },
  { "code": "bn", "name": { "en": "Bengali", "es": "Bengalí" } },
  { "code": "bo", "name": { "en": "Tibetan", "es": "Tibetano" } },
  { "code": "br", "name": { "en": "Breton", "es": "Bretón" } },
  { "code": "bs", "name": { "en": "Bosnian", "es": "Bosnio" } },
  { "code": "ca", "name": { "en": "Catalan, Valencian", "es": "Catalán, valenciano" } },
  { "code": "ce", "name": { "en": "Chechen", "es": "Checheno" } },
  { "code": "ch", "name": { "en": "Chamorro", "es": "Chamorro" } },
  { "code": "co", "name": { "en": "Corsican", "es": "Corso" } },
  { "code": "cr", "name": { "en": "Cree", "es": "Cree" } },
  { "code": "cs", "name": { "en": "Czech", "es": "Checo" } },
  {
    "code": "cu",
    "name": {
      "en": "Church Slavonic, Old Slavonic, Old Church Slavonic",
      "es": "Eslavo eclesiástico, eslavo antiguo, eslavo eclesiástico antiguo"
    }
  },
  { "code": "cv", "name": { "en": "Chuvash", "es": "Chuvasio" } },
  { "code": "cy", "name": { "en": "Welsh", "es": "Galés" } },
  { "code": "da", "name": { "en": "Danish", "es": "Danés" } },
  { "code": "de", "name": { "en": "German", "es": "Alemán" } },
  { "code": "dv", "name": { "en": "Divehi, Dhivehi, Maldivian", "es": "Divehi, dhivehi, maldivo" } },
  { "code": "dz", "name": { "en": "Dzongkha", "es": "Dzongkha" } },
  { "code": "ee", "name": { "en": "Ewe", "es": "Ewé" } },
  { "code": "el", "name": { "en": "Greek, Modern (1453–)", "es": "Griego, moderno (1453–)" } },
  { "code": "en", "name": { "en": "English", "es": "Inglés" } },
  { "code": "eo", "name": { "en": "Esperanto", "es": "Esperanto" } },
  { "code": "es", "name": { "en": "Spanish, Castilian", "es": "Español, castellano" } },
  { "code": "et", "name": { "en": "Estonian", "es": "Estonio" } },
  { "code": "eu", "name": { "en": "Basque", "es": "Euskera" } },
  { "code": "fa", "name": { "en": "Persian", "es": "Persa" } },
  { "code": "ff", "name": { "en": "Fulah", "es": "Fula" } },
  { "code": "fi", "name": { "en": "Finnish", "es": "Finés" } },
  { "code": "fj", "name": { "en": "Fijian", "es": "Fiyiano" } },
  { "code": "fo", "name": { "en": "Faroese", "es": "Feroés" } },
  { "code": "fr", "name": { "en": "French", "es": "Francés" } },
  { "code": "fy", "name": { "en": "Western Frisian", "es": "Frisón occidental" } },
  { "code": "ga", "name": { "en": "Irish", "es": "Irlandés" } },
  { "code": "gd", "name": { "en": "Gaelic, Scottish Gaelic", "es": "Gaélico, gaélico escocés" } },
  { "code": "gl", "name": { "en": "Galician", "es": "Gallego" } },
  { "code": "gn", "name": { "en": "Guarani", "es": "Guaraní" } },
  { "code": "gu", "name": { "en": "Gujarati", "es": "Guyaratí" } },
  { "code": "gv", "name": { "en": "Manx", "es": "Manés" } },
  { "code": "ha", "name": { "en": "Hausa", "es": "Hausa" } },
  { "code": "he", "name": { "en": "Hebrew", "es": "Hebreo" } },
  { "code": "hi", "name": { "en": "Hindi", "es": "Hindi" } },
  { "code": "ho", "name": { "en": "Hiri Motu", "es": "Hiri motu" } },
  { "code": "hr", "name": { "en": "Croatian", "es": "Croata" } },
  { "code": "ht", "name": { "en": "Haitian, Haitian Creole", "es": "Haitiano, criollo haitiano" } },
  { "code": "hu", "name": { "en": "Hungarian", "es": "Húngaro" } },
  { "code": "hy", "name": { "en": "Armenian", "es": "Armenio" } },
  { "code": "hz", "name": { "en": "Herero", "es": "Herero" } },
  {
    "code": "ia",
    "name": {
      "en": "Interlingua (International Auxiliary Language Association)",
      "es": "Interlingua (Asociación Internacional de Lenguas Auxiliares)"
    }
  },
  { "code": "id", "name": { "en": "Indonesian", "es": "Indonesio" } },
  { "code": "ie", "name": { "en": "Interlingue, Occidental", "es": "Interlingue, occidental" } },
  { "code": "ig", "name": { "en": "Igbo", "es": "Igbo" } },
  { "code": "ii", "name": { "en": "Sichuan Yi, Nuosu", "es": "Yi de Sichuan, nuosu" } },
  { "code": "ik", "name": { "en": "Inupiaq", "es": "Inupiaq" } },
  { "code": "io", "name": { "en": "Ido", "es": "Ido" } },
  { "code": "is", "name": { "en": "Icelandic", "es": "Islandés" } },
  { "code": "it", "name": { "en": "Italian", "es": "Italiano" } },
  { "code": "iu", "name": { "en": "Inuktitut", "es": "Inuktitut" } },
  { "code": "ja", "name": { "en": "Japanese", "es": "Japonés" } },
  { "code": "jv", "name": { "en": "Javanese", "es": "Javanés" } },
  { "code": "ka", "name": { "en": "Georgian", "es": "Georgiano" } },
  { "code": "kg", "name": { "en": "Kongo", "es": "Kongo" } },
  { "code": "ki", "name": { "en": "Kikuyu, Gikuyu", "es": "Kikuyu, gikuyu" } },
  { "code": "kj", "name": { "en": "Kuanyama, Kwanyama", "es": "Kuanyama, kuanyama" } },
  { "code": "kk", "name": { "en": "Kazakh", "es": "Kazajo" } },
  { "code": "kl", "name": { "en": "Kalaallisut, Greenlandic", "es": "Groenlandés, groenlandés" } },
  { "code": "km", "name": { "en": "Central Khmer", "es": "Jemer central" } },
  { "code": "kn", "name": { "en": "Kannada", "es": "Canarés" } },
  { "code": "ko", "name": { "en": "Korean", "es": "Coreano" } },
  { "code": "kr", "name": { "en": "Kanuri", "es": "Kanuri" } },
  { "code": "ks", "name": { "en": "Kashmiri", "es": "Cachemir" } },
  { "code": "ku", "name": { "en": "Kurdish", "es": "Kurdo" } },
  { "code": "kv", "name": { "en": "Komi", "es": "Komi" } },
  { "code": "kw", "name": { "en": "Cornish", "es": "Córnico" } },
  { "code": "ky", "name": { "en": "Kyrgyz, Kirghiz", "es": "Kirguís, kirguís" } },
  { "code": "la", "name": { "en": "Latin", "es": "Latín" } },
  { "code": "lb", "name": { "en": "Luxembourgish, Letzeburgesch", "es": "Luxemburgués, luxemburgués" } },
  { "code": "lg", "name": { "en": "Ganda", "es": "Ganda" } },
  { "code": "li", "name": { "en": "Limburgan, Limburger, Limburgish", "es": "Limburgués, limburgués, limburgués" } },
  { "code": "ln", "name": { "en": "Lingala", "es": "Lingala" } },
  { "code": "lo", "name": { "en": "Lao", "es": "Lao" } },
  { "code": "lt", "name": { "en": "Lithuanian", "es": "Lituano" } },
  { "code": "lu", "name": { "en": "Luba-Katanga", "es": "Luba-katanga" } },
  { "code": "lv", "name": { "en": "Latvian", "es": "Letón" } },
  { "code": "mg", "name": { "en": "Malagasy", "es": "Malgache" } },
  { "code": "mh", "name": { "en": "Marshallese", "es": "Marshalés" } },
  { "code": "mi", "name": { "en": "Maori", "es": "Maorí" } },
  { "code": "mk", "name": { "en": "Macedonian", "es": "Macedonio" } },
  { "code": "ml", "name": { "en": "Malayalam", "es": "Malayálam" } },
  { "code": "mn", "name": { "en": "Mongolian", "es": "Mongol" } },
  { "code": "mr", "name": { "en": "Marathi", "es": "Maratí" } },
  { "code": "ms", "name": { "en": "Malay", "es": "Malayo" } },
  { "code": "mt", "name": { "en": "Maltese", "es": "Maltés" } },
  { "code": "my", "name": { "en": "Burmese", "es": "Birmano" } },
  { "code": "na", "name": { "en": "Nauru", "es": "Nauruano" } },
  { "code": "nb", "name": { "en": "Norwegian Bokmål", "es": "Noruego bokmål" } },
  { "code": "nd", "name": { "en": "North Ndebele", "es": "Ndebele septentrional" } },
  { "code": "ne", "name": { "en": "Nepali", "es": "Nepalí" } },
  { "code": "ng", "name": { "en": "Ndonga", "es": "Ndonga" } },
  { "code": "nl", "name": { "en": "Dutch, Flemish", "es": "Neerlandés, flamenco" } },
  { "code": "nn", "name": { "en": "Norwegian Nynorsk", "es": "Noruego nynorsk" } },
  { "code": "no", "name": { "en": "Norwegian", "es": "Noruego" } },
  { "code": "nr", "name": { "en": "South Ndebele", "es": "Ndebele meridional" } },
  { "code": "nv", "name": { "en": "Navajo, Navaho", "es": "Navajo, navajo" } },
  { "code": "ny", "name": { "en": "Chichewa, Chewa, Nyanja", "es": "Chichewa, chewa, nyanja" } },
  { "code": "oc", "name": { "en": "Occitan", "es": "Occitano" } },
  { "code": "oj", "name": { "en": "Ojibwa", "es": "Ojibwa" } },
  { "code": "om", "name": { "en": "Oromo", "es": "Oromo" } },
  { "code": "or", "name": { "en": "Oriya", "es": "Oriya" } },
  { "code": "os", "name": { "en": "Ossetian, Ossetic", "es": "Oseto, osético" } },
  { "code": "pa", "name": { "en": "Punjabi, Panjabi", "es": "Punyabí, punjabi" } },
  { "code": "pi", "name": { "en": "Pali", "es": "Pali" } },
  { "code": "pl", "name": { "en": "Polish", "es": "Polaco" } },
  { "code": "ps", "name": { "en": "Pashto, Pushto", "es": "Pastún, pastún" } },
  { "code": "pt", "name": { "en": "Portuguese", "es": "Portugués" } },
  { "code": "qu", "name": { "en": "Quechua", "es": "Quechua" } },
  { "code": "rm", "name": { "en": "Romansh", "es": "Romanche" } },
  { "code": "rn", "name": { "en": "Rundi", "es": "Kirundi" } },
  { "code": "ro", "name": { "en": "Romanian, Moldavian, Moldovan", "es": "Rumano, moldavo, moldavo" } },
  { "code": "ru", "name": { "en": "Russian", "es": "Ruso" } },
  { "code": "rw", "name": { "en": "Kinyarwanda", "es": "Kinyarwanda" } },
  { "code": "sa", "name": { "en": "Sanskrit", "es": "Sánscrito" } },
  { "code": "sc", "name": { "en": "Sardinian", "es": "Sardo" } },
  { "code": "sd", "name": { "en": "Sindhi", "es": "Sindi" } },
  { "code": "se", "name": { "en": "Northern Sami", "es": "Sami septentrional" } },
  { "code": "sg", "name": { "en": "Sango", "es": "Sango" } },
  { "code": "si", "name": { "en": "Sinhala, Sinhalese", "es": "Cingalés, cingalés" } },
  { "code": "sk", "name": { "en": "Slovak", "es": "Eslovaco" } },
  { "code": "sl", "name": { "en": "Slovenian", "es": "Esloveno" } },
  { "code": "sm", "name": { "en": "Samoan", "es": "Samoano" } },
  { "code": "sn", "name": { "en": "Shona", "es": "Shona" } },
  { "code": "so", "name": { "en": "Somali", "es": "Somalí" } },
  { "code": "sq", "name": { "en": "Albanian", "es": "Albanés" } },
  { "code": "sr", "name": { "en": "Serbian", "es": "Serbio" } },
  { "code": "ss", "name": { "en": "Swati", "es": "Suazi" } },
  { "code": "st", "name": { "en": "Southern Sotho", "es": "Sotho meridional" } },
  { "code": "su", "name": { "en": "Sundanese", "es": "Sundanés" } },
  { "code": "sv", "name": { "en": "Swedish", "es": "Sueco" } },
  { "code": "sw", "name": { "en": "Swahili", "es": "Suajili" } },
  { "code": "ta", "name": { "en": "Tamil", "es": "Tamil" } },
  { "code": "te", "name": { "en": "Telugu", "es": "Telugu" } },
  { "code": "tg", "name": { "en": "Tajik", "es": "Tayiko" } },
  { "code": "th", "name": { "en": "Thai", "es": "Tailandés" } },
  { "code": "ti", "name": { "en": "Tigrinya", "es": "Tigriña" } },
  { "code": "tk", "name": { "en": "Turkmen", "es": "Turcomano" } },
  { "code": "tl", "name": { "en": "Tagalog", "es": "Tagalo" } },
  { "code": "tn", "name": { "en": "Tswana", "es": "Setsuana" } },
  { "code": "to", "name": { "en": "Tonga (Tonga Islands)", "es": "Tonga (Islas Tonga)" } },
  { "code": "tr", "name": { "en": "Turkish", "es": "Turco" } },
  { "code": "ts", "name": { "en": "Tsonga", "es": "Tsonga" } },
  { "code": "tt", "name": { "en": "Tatar", "es": "Tártaro" } },
  { "code": "tw", "name": { "en": "Twi", "es": "Akan" } },
  { "code": "ty", "name": { "en": "Tahitian", "es": "Tahitiano" } },
  { "code": "ug", "name": { "en": "Uighur, Uyghur", "es": "Uigur, uigur" } },
  { "code": "uk", "name": { "en": "Ukrainian", "es": "Ucraniano" } },
  { "code": "ur", "name": { "en": "Urdu", "es": "Urdu" } },
  { "code": "uz", "name": { "en": "Uzbek", "es": "Uzbeko" } },
  { "code": "ve", "name": { "en": "Venda", "es": "Venda" } },
  { "code": "vi", "name": { "en": "Vietnamese", "es": "Vietnamita" } },
  { "code": "vo", "name": { "en": "Volapük", "es": "Volapük" } },
  { "code": "wa", "name": { "en": "Walloon", "es": "Valón" } },
  { "code": "wo", "name": { "en": "Wolof", "es": "Wólof" } },
  { "code": "xh", "name": { "en": "Xhosa", "es": "Xhosa" } },
  { "code": "yi", "name": { "en": "Yiddish", "es": "Yidis" } },
  { "code": "yo", "name": { "en": "Yoruba", "es": "Yoruba" } },
  { "code": "za", "name": { "en": "Zhuang, Chuang", "es": "Zhuang, zhuang" } },
  { "code": "zh", "name": { "en": "Chinese", "es": "Chino" } },
  { "code": "zu", "name": { "en": "Zulu", "es": "Zulú" } }
]
